// **************** ROUTE CONSTANT START **************************
// General Page Section
export const DASHBOARD = "/dashboard";
export const USERS = "/users";
export const QUESTIONNAIRE = "/questionnaire";
export const OVERVIEWTEMPLATE = "/overview-template";
export const PRODUCTS = "/products";
export const CATEGORY = "/category";
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const ORDERS = "/orders";
export const CUSTOMERS = "/customers";
export const COUPONS = "/coupons";
export const SETTINGS = "/settings";
export const STAFF_MEMBERS = "/staff-members";
export const SITE_SETTINGS = "/site-settings";
export const PRIZE_WINNERS = "/prize-winners";
export const LANDING_PAGE = "landing-page";
export const PAT01 = "pat01";
export const PAT02 = "pat02";
export const PAT03 = "pat03";
export const PAT04 = "pat04";
export const CONTACT_FORM1 = `/contact-${PAT01}`;
export const CONTACT_FORM2 = `/contact-${PAT02}`;
export const CONTACT_FORM3 = `/contact-${PAT03}`;
export const SUCCESSFORM1 = `/thanks-${PAT01}`;
export const SUCCESSFORM2 = `/thanks-${PAT02}`;
export const SUCCESSFORM3 = `/thanks-${PAT03}`;
export const ALBION = "/landing-albion";
export const EVENT = "/event";
export const FORGOT_PASS = "/forgot-pass";
export const VIDEO = "/video";
export const PDF_EXPORT = "/preview-pdf";
export const FORMPRIZE = "/contact";
export const FORMCONFIRM = "/form-confirm";
export const SUCCESSFORM_SPECIAL = "/thanks";
export const SUCCESSFORM = "/success-form";
export const LANDING_PAGE1 = "/hamamatsuri-week1";
export const LANDING_PAGE2 = "/hamamatsuri-week2";
export const LANDING_PAGE3 = "/hamamatsuri-week3";
export const LANDING_PAGE4 = "/hamamatsuri-week4";
export const LANDING_PAGE5 = "/hamamatsuri-week5";
export const FORMPRIZE1 = "/hamamatsuri-form-prize1";
export const FORMPRIZE2 = "/hamamatsuri-form-prize2";
export const FORMPRIZE3 = "/hamamatsuri-form-prize3";
export const FORMPRIZE4 = "/hamamatsuri-form-prize4";
export const FORMPRIZE5 = "/hamamatsuri-form-prize5";
export const LANDING_PAGE_AUTHEN = "landing-page-auth";
export const NOT_FOUND_EVENT = "/event-error";

export const LOTTERY = "/lottery";
// **************** ROUTE CONSTANT END **************************

export const CURRENCY = "$";

export const AWS_S3_FOLDER_NAME = {
  VERMUDA_IMAGES: "vermuda-images/",
  IMAGES: "images/",
  VIDEOS: "videos/",
};
